"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const react_helmet_1 = require("react-helmet");
const uuid_1 = require("uuid");
const react_router_1 = require("react-router");
const mui_1 = require("tss-react/mui");
const react_use_1 = require("react-use");
const core_1 = require("companion-app-components/utils/core");
const budget_items_1 = require("companion-app-components/flux/budget-items");
const selectors_1 = require("data/datasetSharing/selectors");
const BudgetHeader_1 = __importDefault(require("containers/BudgetsV2/components/BudgetHeader"));
const BudgetEmbedded_1 = __importDefault(require("containers/BudgetsV2/components/BudgetEmbedded"));
const helpers_1 = require("containers/OverviewPage/components/helpers");
const constants_1 = require("containers/BudgetsV2/constants");
const config_1 = require("containers/SetupPage/GettingStartedWebFirst/config");
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const QButton_1 = __importDefault(require("components/QButton"));
const WFBudgetSetup_1 = __importDefault(require("components/Dialogs/WFBudgetSetup"));
const EditBudgetsDialog_1 = __importDefault(require("components/Budgets/EditBudgetsDialog"));
const GettingStartedModule_1 = __importDefault(require("components/GettingStartedModule"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const budgets_svg_1 = __importDefault(require("assets/zero-state-images/budgets.svg"));
const under_construction_png_1 = __importDefault(require("assets/under-construction.png"));
const utils_1 = require("./utils");
const styles_1 = __importDefault(require("./styles"));
const staticConfigWF = (0, config_1.staticConfig)(true, false, true);
const budgetConfig = staticConfigWF.length && staticConfigWF.length >= 3 && staticConfigWF[2]; // Get third element Budgets
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const BudgetsV2 = ({ loadPending, isLoading, hasReportableAccounts, budgets, budget, budgetItems, navigationPath, budgetTreeNode, budgetTreeNodes, transactions, budgetsEnabled, budgetAccountIds, budgetsCreation, isWebFirstDataset, preferences, dialogAlert, uiState, dashboardRef, setUIState, dispatchGetUserPreferencesAction, dispatchBudgetFullCalcCall, dispatchSetSharedDatasetPreferenceAction, dispatchSetSharedWebAppDatasetPreferenceAction, dispatchGetBudgetsAction, dispatchGetBudgetItemsAction, dispatchGetCategoryGroupListsAction, dispatchGetCategoryGroupsAction, dispatchGetCategoriesAction, dispatchGetPreferencesAction, dispatchGetTransactionsAction, dispatchDeleteBudgetAction, dispatchCreateBudgetItemsAction, }) => {
    const navigate = (0, react_router_1.useNavigate)();
    const isCurrentDatasetOwner = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIsCurrentDatasetOwner)(state));
    const { classes, theme } = useStyles();
    const [showEditDialog, setShowEditDialog] = (0, react_1.useState)(false);
    const [showNewBudgetSetup, setShowNewBudgetSetup] = (0, react_1.useState)(false);
    const prevUiState = (0, react_1.useRef)(uiState);
    const prevLoadPending = (0, react_1.useRef)(loadPending);
    const prevIsLoading = (0, react_1.useRef)(isLoading);
    const prevNavigationPath = (0, react_1.useRef)(navigationPath);
    const prevBudget = (0, react_1.useRef)(budget);
    const goToDate = (date) => {
        setUIState(Object.assign(Object.assign({}, uiState), { startDate: new Date(date.getFullYear(), date.getMonth(), 1), endDate: new Date(date.getFullYear(), date.getMonth() + 1, 0) }));
    };
    const refreshData = () => {
        dispatchGetBudgetsAction();
        dispatchGetBudgetItemsAction();
        dispatchGetCategoryGroupListsAction();
        dispatchGetCategoryGroupsAction();
        dispatchGetCategoriesAction();
        dispatchGetPreferencesAction();
        dispatchGetTransactionsAction();
    };
    const budgetFullCalcTrigger = (budgetId) => {
        var _a, _b, _c;
        const fullCalcTriggeredList = ((_c = (_b = (_a = preferences === null || preferences === void 0 ? void 0 : preferences.shared) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.budgetOptions) === null || _c === void 0 ? void 0 : _c.fullCalcTriggeredList) || [];
        if (!fullCalcTriggeredList.includes(budgetId)) {
            dispatchBudgetFullCalcCall(budgetId);
        }
    };
    (0, react_use_1.useEffectOnce)(() => {
        goToDate(new Date());
        if (!isLoading) {
            dispatchGetUserPreferencesAction();
            refreshData();
        }
        const budgetId = budget === null || budget === void 0 ? void 0 : budget.id;
        if (budgetId) {
            setTimeout(() => {
                budgetFullCalcTrigger(budgetId);
            }, 1000);
        }
    });
    const createNewBudget = (0, react_1.useCallback)((startDate, budgetItemsPriorYear, monthByMonth) => {
        let allBudgetItemsToSave = (0, immutable_1.List)();
        // iterate over 12 months
        for (let month = 0; month < 12; month++) {
            const copyMonth = monthByMonth ? month : 11;
            const budgetItemsToCopy = budgetItemsPriorYear.filter((x) => luxon_1.DateTime.fromISO(x.startDate).month === copyMonth);
            const budgetItemsToSave = budgetItemsToCopy.map((item) => budget_items_1.budgetItemsTypes.mkBudgetItem({
                clientId: (0, uuid_1.v4)().toUpperCase(),
                budgetId: budget.id,
                startDate: luxon_1.DateTime.fromISO(startDate).set({ month }).toFormat('yyyy-MM-dd'),
                amount: item.amount,
                groupId: item.groupId,
                type: item.type,
                coa: item.coa,
                calculatedActualsAmount: undefined,
                // @ts-expect-error: Object literal may only specify known properties,
                calclulatedRolloverAmount: undefined,
            }));
            allBudgetItemsToSave = allBudgetItemsToSave.concat(budgetItemsToSave.toList());
        }
        dispatchCreateBudgetItemsAction(allBudgetItemsToSave);
    }, [dispatchCreateBudgetItemsAction, budget]);
    const checkBudgetExistence = (0, react_1.useCallback)(() => {
        const { startDate } = uiState;
        if (!budget)
            return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const budgetItemsViewingYear = budgetItems.filter((x) => x.budgetId === budget.id && (luxon_1.DateTime.fromISO(x.startDate).year === luxon_1.DateTime.fromISO(startDate).year));
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const budgetItemsPriorYear = budgetItems.filter((x) => x.budgetId === budget.id && (luxon_1.DateTime.fromISO(x.startDate).year === (luxon_1.DateTime.fromISO(startDate).year - 1)));
        // if the year being viewed has no budgetItems, but the year PRIOR to it does, then
        // offer to create items for that year.
        if (isLoading || loadPending || budgetItemsViewingYear.size > 0 || budgetItemsPriorYear.size === 0) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const { year } = luxon_1.DateTime.fromISO(startDate);
        const priorYear = Number(year) - 1;
        if (budgetTreeNodes && budgetTreeNodes.size < 1) {
            dialogAlert(`Create budget for ${year}?`, `Quicken creates budgets one year at a time, and you currently do not have a budget defined for ${year}. ` +
                `Would you like to create a ${year} budget based on your budget for ${priorYear}?`, (ret) => {
                if (ret.btnPressed.includes('Yes')) {
                    // TODO create budget items for the next year
                    const monthByMonth = !(ret.btnPressed.includes('December'));
                    createNewBudget(startDate, budgetItemsPriorYear, monthByMonth);
                }
            }, [`Yes, copy each month from ${priorYear}`, `Yes, copy from December, ${priorYear}`, 'No'], 'info');
        }
    }, [
        dialogAlert,
        uiState,
        budgetTreeNodes,
        budgetItems,
        isLoading,
        loadPending,
        budget,
        createNewBudget,
    ]);
    (0, react_1.useEffect)(() => {
        if (budgetsCreation && isWebFirstDataset &&
            (uiState.startDate !== prevUiState.current.startDate ||
                loadPending !== prevLoadPending.current ||
                isLoading !== prevIsLoading.current)) {
            checkBudgetExistence();
        }
        // Update previous values
        prevUiState.current = uiState;
        prevLoadPending.current = loadPending;
        prevIsLoading.current = isLoading;
    }, [
        budgetsCreation,
        isWebFirstDataset,
        uiState,
        loadPending,
        isLoading,
        checkBudgetExistence,
    ]);
    const fullNavPath = (params) => {
        let navPath;
        if (params.navigationPath && params.budget) {
            navPath = [params.budget.id, ...params.navigationPath.map((node) => node.id)];
        }
        else if (params.budget) {
            navPath = [params.budget.id];
        }
        return navPath;
    };
    (0, react_1.useEffect)(() => {
        const navPath = fullNavPath({ navigationPath, budget });
        const prevNavPath = fullNavPath({ prevNavigationPath, prevBudget });
        if (JSON.stringify(navPath) !== JSON.stringify(prevNavPath)) {
            const nodesType = budgetTreeNodes === null || budgetTreeNodes === void 0 ? void 0 : budgetTreeNodes.reduce((results, node) => {
                const resultsMutable = results;
                resultsMutable.isExpense = resultsMutable.isExpense || node.negate < 0;
                resultsMutable.isIncome = resultsMutable.isIncome || node.negate > 0;
                return resultsMutable;
            }, {
                isIncome: false,
                isExpense: false,
            });
            let groupType;
            if (nodesType && nodesType.isIncome && !nodesType.isExpense) {
                groupType = 'income';
            }
            else if (nodesType && nodesType.isExpense && !nodesType.isIncome) {
                groupType = 'expense';
            }
            else {
                groupType = 'dynamic';
            }
            core_1.tracker.track(core_1.tracker.events.budgetView, { group_type: groupType, level: navPath && (navPath.length - 1) });
            prevBudget.current = budget;
            prevNavigationPath.current = navigationPath;
        }
    }, [navigationPath, budget, budgetTreeNodes]);
    const goPrevMonth = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const newDate = new Date(uiState.startDate.getFullYear(), uiState.startDate.getMonth() - 1, 1);
        goToDate(newDate);
        core_1.tracker.track(core_1.tracker.events.budgetChange, { type: 'prev_date' });
    };
    const goThisMonth = () => {
        goToDate(new Date());
        core_1.tracker.track(core_1.tracker.events.budgetChange, { type: 'cur_date' });
    };
    const goNextMonth = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const newDate = new Date(uiState.startDate.getFullYear(), uiState.startDate.getMonth() + 1, 1);
        goToDate(newDate);
        core_1.tracker.track(core_1.tracker.events.budgetChange, { type: 'next_date' });
    };
    const handleNavigationClick = (node) => {
        if (budget) {
            if (node) {
                navigate(`/budgets?displayBudget=${budget.id}&displayNode=${node.key}`, { replace: true });
            }
            else {
                navigate(`/budgets?displayBudget=${budget.id}`, { replace: true });
            }
        }
    };
    const handleBudgetChange = (event) => {
        if (event.target && event.target.value) {
            dispatchSetSharedDatasetPreferenceAction({ budgetOptions: { lastViewedBudgetId: event.target.value } });
            setUIState(Object.assign(Object.assign({}, uiState), { selectedAnnualBudgetItem: null }));
            navigate(`/budgets?displayBudget=${event.target.value}`, { replace: true });
            goThisMonth();
            core_1.tracker.track(core_1.tracker.events.budgetChange, { type: 'budget' });
            budgetFullCalcTrigger(event.target.value);
        }
    };
    const handleViewChange = ({ id, name }, annualSubView, event) => {
        if (event.target.value === constants_1.BUDGET_VIEWS.annual.key) {
            navigate(`/budgets?displayBudget=${id}`, { replace: true });
        }
        dispatchSetSharedWebAppDatasetPreferenceAction((0, utils_1.getBudgetViewStateObject)(id, name, event.target.value, annualSubView, (0, utils_1.getKeyFutureMonthsVisibility)(annualSubView)));
        core_1.tracker.track(core_1.tracker.events.budgetViewChange, { changedBudgetView: event.target.value });
    };
    const handleAnnualSubViewChange = ({ id, name }, budgetView, event) => {
        const annualSubView = event.target.value;
        dispatchSetSharedWebAppDatasetPreferenceAction((0, utils_1.getBudgetViewStateObject)(id, name, budgetView, annualSubView, (0, utils_1.getKeyFutureMonthsVisibility)(annualSubView)));
        core_1.tracker.track(core_1.tracker.events.annualBudgetViewChange, { annualViewType: constants_1.BUDGET_ANNUAL_SUBVIEWS[annualSubView].label });
    };
    const updateBudget = () => {
        dispatchGetBudgetItemsAction();
    };
    const deleteBudget = () => {
        if (!budget)
            return;
        dialogAlert(`Delete the budget "${budget.name}"`, `This will delete the budget "${budget.name}" and all its items.  This cannot be undone. Are you sure?`, (ret) => {
            if (ret.btnPressed === 'Yes') {
                dispatchDeleteBudgetAction(budget.set('isDeleted', true));
            }
        }, ['Yes', 'Cancel'], 'delete', false);
    };
    const isUiStateReady = Boolean((uiState === null || uiState === void 0 ? void 0 : uiState.startDate) && (uiState === null || uiState === void 0 ? void 0 : uiState.endDate));
    const hasBudgets = Boolean(budgets === null || budgets === void 0 ? void 0 : budgets.size);
    const shouldShowBlockingLoading = !isUiStateReady || (isLoading && !hasBudgets);
    const normalizedLoadPending = loadPending || undefined;
    const view = (0, helpers_1.computeViewState)(() => shouldShowBlockingLoading, () => !(budgets && budgets.size), hasReportableAccounts, normalizedLoadPending, !budgetsEnabled);
    return (<div style={{ height: '100%' }}>
      <react_helmet_1.Helmet>
        <title>Budgets</title>
      </react_helmet_1.Helmet>

      {view === helpers_1.ViewStateEnum.DISABLED &&
            <img alt="page is under construction" src={under_construction_png_1.default} style={{
                    display: 'block',
                    width: '50%',
                    marginTop: 40,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}/>}

      {view === helpers_1.ViewStateEnum.LOADING &&
            <LoadingView_1.default style={{ height: theme.defaults.content.height }}/>}

      {view === helpers_1.ViewStateEnum.LOAD_PENDING &&
            <ZeroStateView_1.default style={{ margin: 40 }} primary="No Data" icon={budgets_svg_1.default} secondary="We can't fetch your data from the server. Please try to refresh the page."/>}

      {(view === helpers_1.ViewStateEnum.ZERO || view === helpers_1.ViewStateEnum.EMPTY) && (!isWebFirstDataset || !isCurrentDatasetOwner) &&
            <ZeroStateView_1.default primary="" style={{ margin: 'auto', height: theme.defaults.content.height }} icon={budgets_svg_1.default} secondary={isCurrentDatasetOwner ? "It looks like you don't have a budget set up. If you have a budget set up on the desktop, be sure to sync it first." +
                    `${budgetsCreation && isWebFirstDataset ? "Or you can create a budget from here by clicking 'Create' " : ''}` :
                    'It looks like you don’t have a budget set up. Creating budgets on shared datasets is not supported.'}>
          {budgetsCreation && isWebFirstDataset && isCurrentDatasetOwner &&
                    <div style={{ marginBottom: 25 }}>
              <QButton_1.default variant="contained" onClick={() => setShowNewBudgetSetup(true)}>
                Create a Budget
              </QButton_1.default>
            </div>}
        </ZeroStateView_1.default>}

      {(view === helpers_1.ViewStateEnum.ZERO || view === helpers_1.ViewStateEnum.EMPTY || (view === helpers_1.ViewStateEnum.MAIN && showNewBudgetSetup)) &&
            isWebFirstDataset && budgetConfig && isCurrentDatasetOwner && (<div className={classes.gettingStartedModuleRoot}>
          <GettingStartedModule_1.default config={budgetConfig}/>
          <div className={classes.buttonArea}>
            {budgetConfig.buttons.map((btn) => <div key={`SETUPBTN: ${btn.value}`}>
                <QButton_1.default variant="contained" classes={{ conButton: classes.setupButton }} onClick={() => btn.value === 'createBudget' && setShowNewBudgetSetup(true)} id={btn.id}>
                  {btn.label}
                </QButton_1.default>
              </div>)}
          </div>
        </div>)}

      {view === helpers_1.ViewStateEnum.MAIN && !showNewBudgetSetup &&
            <div>
          <RendersCount_1.default id="budget-header"/>
          <BudgetHeader_1.default isLoading={view === helpers_1.ViewStateEnum.LOADING} budget={budget} budgets={budgets} budgetsCreation={budgetsCreation && isWebFirstDataset && isCurrentDatasetOwner} startDate={uiState.startDate} goNextMonth={goNextMonth} goPrevMonth={goPrevMonth} goThisMonth={goThisMonth} handleBudgetChange={handleBudgetChange} onEdit={() => setShowEditDialog(true)} onDelete={deleteBudget} handleViewChange={handleViewChange} handleAnnualSubViewChange={handleAnnualSubViewChange} dashboardRef={dashboardRef}/>
          <BudgetEmbedded_1.default isLoading={view === helpers_1.ViewStateEnum.LOADING} budgetsCreation={budgetsCreation && isWebFirstDataset && isCurrentDatasetOwner} budget={budget} accountIds={budgetAccountIds} navigationPath={navigationPath} budgetTreeNodes={budgetTreeNode ? (0, immutable_1.List)([budgetTreeNode]) : budgetTreeNodes} transactions={transactions} onTxnUpdate={updateBudget} handleNavigationClick={handleNavigationClick} dashboardRef={dashboardRef} budgetUiState={uiState} setBudgetUiState={setUIState}/>
        </div>}
      {showNewBudgetSetup &&
            <WFBudgetSetup_1.default onClose={() => setShowNewBudgetSetup(false)}/>}
      {showEditDialog &&
            <EditBudgetsDialog_1.default onClose={() => setShowEditDialog(false)} budget={budget} startDate={uiState.startDate} 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            month={luxon_1.DateTime.fromISO(uiState.startDate).toFormat('MM')} budgetTreeNodes={budgetTreeNodes}/>}
    </div>);
};
exports.default = BudgetsV2;
